import { useEffect, useState } from "react";
import { STATUS } from "@/mock/data";
import { api } from "@/lib/api";
import { hoyISO } from "@/lib/zona";
import { itemsAtencion, itemsProximas, personasDe } from "@/lib/inicio";

export const useGestiones = () => {
  const [gs, setGs] = useState([]);
  useEffect(() => {
    const cargar = () => api.get("/gestiones").then((r) => setGs(r.data)).catch(() => {});
    cargar();
    window.addEventListener("aldia-gestiones", cargar);
    return () => window.removeEventListener("aldia-gestiones", cargar);
  }, []);
  return gs;
};

// Misma fuente que Inicio (itemsAtencion/itemsProximas + ocurrencias), filtrada por persona.
export const agendaPersona = ({ p, matters, reminders, gestiones, ocs, familyMembers }) => {
  const hoy = hoyISO();
  const de = personasDe(familyMembers);
  const mio = (i) => i.personas.includes(p.id);
  const atTodas = itemsAtencion({ matters, reminders, familyMembers });
  const proximos = itemsProximas({ matters, reminders, gestiones, familyMembers, excluir: new Set(atTodas.map((i) => i.id)) }).filter(mio);
  const gPorId = Object.fromEntries((gestiones || []).map((g) => [g.id, g]));
  const ocsP = (ocs || []).filter((o) => gPorId[o.gestion_id] && de.gestion(gPorId[o.gestion_id]).includes(p.id))
    .map((o) => ({ id: o.id, kind: "periodico", titulo: o.titulo, fecha: o.fecha, ruta: `/gestiones/${o.gestion_id}`, grupo: o.fecha < hoy ? 0 : 1, etiqueta: o.fecha < hoy ? "Atrasado" : "Para hoy" }));
  const atencion = [...atTodas.filter(mio), ...ocsP];
  const grupos = {
    atrasados: atencion.filter((i) => i.grupo === 0), hoy: atencion.filter((i) => i.grupo === 1),
    atencion: atencion.filter((i) => i.grupo === 2), proximos,
  };
  const enAgenda = new Set([...atencion, ...proximos].map((i) => i.id));
  const asuntos = matters.filter((m) => de.matter(m).includes(p.id) && !enAgenda.has(m.id));
  const anteriores = (gestiones || []).filter((g) => !g.en_papelera && g.estado !== "activa" && de.gestion(g).includes(p.id));
  return {
    grupos, asuntos, anteriores, total: atencion.length + proximos.length,
    contadores: { attention: atencion.length, upcoming: proximos.length, controlled: asuntos.filter((m) => m.status === STATUS.CONTROLLED).length },
  };
};
